// src/pages/ApplicationChampionship/components/ChampionshipCreateModal/schemas.ts
import { t } from '@/i18n';
import { z } from 'zod';

export const modalFormSchema = z.object({
  name: z.string().min(1, t('pages.application_championship.components.schema.championship_create_schema_required')),
  is_filtered: z.boolean(),
  is_active: z.boolean(),
});

export type ModalFormData = z.infer<typeof modalFormSchema>;
